var YouLi = YouLi ? YouLi : {};
YouLi.Trip = YouLi.Trip ? YouLi.Trip : {};
YouLi.Trip.Tasks = YouLi.Trip.Tasks ? YouLi.Trip.Tasks : {};

(function (YouLi) {
    (function (Trip) {
        (function (Tasks) {

            YouLi.Trip.Tasks.FilterTasks = function () {
                if (YouLi.Trip.ShowCompleted) {
                    $(".tasks-accordion-item.completed:not('.completing')").show();
                }
                else {
                    $(".tasks-accordion-item.completed:not('.completing')").hide();
                }
                $(".filter-action-label").text(YouLi.Trip.ShowCompleted ? "Hide" : "Show");
            };

            YouLi.Trip.Tasks.TaskRespondFormSuccess = function (result) {

                if (result.cookieError && result.message) {
                    YouLi.Common.UI.HideLoading();
                    YouLi.Common.UI.ShowStaticStandardDialogNoClose(result.message, "Identity error");
                }

                var formSubmitBtn = $("form").find("button[type='submit']");
                YouLi.Common.UI.HideButtonLoading(formSubmitBtn);

                if (result.errors) {
                    YouLi.Common.UI.ClearClientSideErrors();
                    YouLi.Common.UI.FormatClientSideErrors(result.errors);

                    $('#question-dialog').animate({ scrollTop: 0 }, 800);
                } else {
                    // get and restore collapsible panel states
                    var openPanelIds = $(".panel-collapse.collapse.in").map(function () { return this.id; }).get();

                    $('#tasks-content').html(result.contentTasksHtml);
                    $('.trip-heading-title').html(result.tripHeadingTitle);
                    $('.trip-content-heading').html(result.tripContentHeadingHtml);

                    if ($('#content-trip-viewprofile').length > 0 && !$("#content-trip-viewprofile").hasClass("hidden")) {
                        $('#view-profile-content').html(result.currentInviteeProfileHtml);
                        $("#content-trip-viewprofile").removeClass("hidden");   // show it as it was previously being shown
                    }

                    RefreshInviteesTab(result.inviteesDetailsHtmlString, result.showInvitees);

                    if (YouLi.Trip.Payments != undefined)
                        YouLi.Trip.Payments.BillToEmail = result.currentInviteeEmail;

                    if (openPanelIds.length > 0) {
                        $('#' + openPanelIds.join(',#')).collapse("show");
                    }
                    YouLi.Trip.Tasks.FilterTasks();
                    $('#question-dialog').modal('hide');
                    $("#content-trip-tasks").toggleClass("hidden", YouLi.Trip.CurrentSection != "tasks");

                    // Refresh itinerary tab - we replace the whole thing beacuse too much may have changed such as the not-going items being at the bottom
                    let itineraryTabIsHidden = $("#content-trip-itinerary").hasClass("hidden");
                    YouLi.Trip.UpdateItineraryContent(itineraryTabIsHidden, result.newContentItineraryHtml);
                    YouLi.Trip.Schedule.Response.InitialiseResponseChecks();

                    // Refresh the payments tab contents
                    $("#SelectedCouponCode").val("");
                    $('#payment-detail-content').html(result.newPaymentDetailsHtml);
                    $('.content-trip-heading-details-cost').html(result.newCostSummaryHtml);

                    // Update payment info - but only if the server has passed it back
                    if ($(".content-trip-paymentdetails-payment-info").length > 0 && result.newPaymentInfoHtml.length > 0)
                        $(".content-trip-paymentdetails-payment-info").html(result.newPaymentInfoHtml);

                    YouLi.Trip.Payments.RefreshPaymentMethod(true);
                    YouLi.Trip.Payments.InitialiseUI();

                    setTimeout(function () {
                        // animate the hiding of the just-completed task (if it was completed)
                        if (!YouLi.Trip.ShowCompleted) {
                            $(".completing").fadeOut(1000, function () {
                                $(".completing").removeClass("completing");
                            });
                        }
                        else {
                            $(".completing").removeClass("completing");
                        }
                    }, 1000);

                    YouLi.Trip.UpdateResponseFooter(runOnce = true, checkTripUpdates = false);
                }

            };

            YouLi.Trip.Tasks.TaskRespondFormFailure = function (xhr, status, error) {
                var formSubmitBtn = $("form").find("button[type='submit']");
                YouLi.Common.UI.HideButtonLoading(formSubmitBtn);

                YouLi.Common.UI.ClearClientSideErrors();
                YouLi.Common.UI.FormatClientSideErrors(error, xhr);

                $('#question-dialog').animate({ scrollTop: 0 }, 800);
            };

            var RefreshInviteesTab = function (tabHTML, showInviteeTab) {
                if (showInviteeTab) {
                    // Display and refresh invitees tab (if not already displayed)
                    $(".content-tab-invitees").removeClass("hidden");

                    $("#invitees-content").html(tabHTML);

                    YouLi.Trip.SetupInviteeSectionMenu();
                }
            }

            $(function () {

                // Response functionality
                $(document).on("click touchstart", ".task-do-response", function () {

                    const taskItemId = $(this).data("task-item-id");
                    const inviteeId = $(this).data("task-invitee-id") || $("#InviteeId").val();
                    const previewMode = $("#PreviewMode").val();

                    YouLi.Common.Get({
                        url: '/trip/taskrespond',
                        params: { taskItemId: taskItemId, inviteeid: inviteeId, preview: previewMode },
                    }).then(function (response) {
                        $("#question-dialog-content").html(response);
                        $('#question-dialog').modal('show');
                    });
                });

                $(document).on("click", "#FilterTasks", function () {
                    // toggle filter
                    YouLi.Trip.ShowCompleted = !YouLi.Trip.ShowCompleted;
                    YouLi.Trip.Tasks.FilterTasks();
                });

                // initially hide or show completed, depending on number of tasks outstanding
                YouLi.Trip.Tasks.FilterTasks();

            });

        }(YouLi.Trip.Tasks ? YouLi.Trip.Tasks : {}));
    }(YouLi.Trip ? YouLi.Trip : {}));
}(YouLi ? YouLi : {}));